/**
 * @generated SignedSource<<766267f2a1c94103f5a30f040a6260f4>>
 * @relayHash 37ad7e4470edca57db1b559b865fb655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b17c4c0654abced26a7b9a4157ebf319e48dbab2f71da56fb795f76cca95b3e8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessApprovalsProjectSettingsAppMemoQuery } from './JiraBusinessApprovalsProjectSettingsAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessApprovalsProjectSettingsAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b17c4c0654abced26a7b9a4157ebf319e48dbab2f71da56fb795f76cca95b3e8",
    "metadata": {},
    "name": "JiraBusinessApprovalsProjectSettingsAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
